<header class="data-table__header">
  <h1 class="page-heading">
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
      <g fill="none" fill-rule="evenodd">
        <g fill="#0CC5D1">
          <path d="M29.8.69v30.768h-28V.69l6.336 2.3 3.279-1.984 4.385 1.99 4.385-1.99 3.28 1.985L29.8.69zM20.03 3.26l-4.23 1.92-4.23-1.92-3.182 1.926-4.434-1.61v25.926h23.692V3.577l-4.434 1.61L20.03 3.26zm-3.153 6.692v1.989c1.842.233 3.23 1.645 3.23 3.387v.978h-2.153v-.978c0-.828-.703-1.466-1.616-1.466h-1.076c-.913 0-1.616.638-1.616 1.466 0 .698.346.98 1.781 1.345l.985.233c2.62.63 3.696 1.336 3.696 3.31 0 1.742-1.39 3.155-3.231 3.388v1.988h-2.154v-1.988c-1.842-.233-3.23-1.646-3.23-3.388v-.977h2.153v.977c0 .829.703 1.466 1.616 1.466h1.076c.913 0 1.616-.637 1.616-1.466 0-.698-.346-.98-1.781-1.344l-.985-.233c-2.62-.63-3.696-1.336-3.696-3.31 0-1.743 1.39-3.155 3.231-3.388V9.953h2.154z" transform="translate(-96 -174) translate(93 171) translate(3 3)" />
        </g>
      </g>
    </svg>
    <ng-container i18n="@@payments">Payments</ng-container>
  </h1>
  <!-- data-table__heading -->
  <!-- <div class="payment-info">

    <div class="payment-item">
      <div class="payAmount">
        <div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
        <div class="amountNum">{{ (total > 0 && total > 1000) ? (total| shortNumber) : (total| number:'.2') }} </div>
      </div>
      <small>
        <ng-container i18n="@@payments.all_invoices">All Invoices</ng-container>
      </small>
    </div>

    <div class="payment-item">
      <div class="payAmount">
        <div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
        <div class="amountNum">{{ (pendingInvoicesSum > 0 && pendingInvoicesSum > 1000) ? (pendingInvoicesSum | shortNumber) : (pendingInvoicesSum | number:'.2') }}</div>
      </div>
      <small>
        <ng-container i18n="@@payments.open_invoices">Open Invoices</ng-container>
      </small>
    </div>

    <div class="payment-item">
      <div class="payAmount">
        <div class="amountSar" [innerHtml]="userInfo?.currency_symbol"></div>
        <div class="amountNum">{{ (closedInvoicesSum > 0 && closedInvoicesSum > 1000) ? (closedInvoicesSum | shortNumber) : (closedInvoicesSum | number:'.2') }}</div>
      </div>
      <small>
        <ng-container i18n="@@payments.paid_invoices">Paid Invoices</ng-container>
      </small>
    </div>
  </div> -->
  <!-- end payment-info -->
</header>
<!-- end billing-header -->